import { supabase } from '../lib/supabase';

export const storageService = {
  async uploadUserAvatar(file, userId) {
    try {
      const fileExt = file?.name?.split('.')?.pop();
      const fileName = `${Date.now()}.${fileExt}`;
      const filePath = `${userId}/${fileName}`;

      const { data, error } = await supabase?.storage
        ?.from('user-avatars')
        ?.upload(filePath, file, {
          cacheControl: '3600',
          upsert: false
        });

      if (error) throw error;
      return { data: filePath, error: null };
    } catch (error) {
      console.error('Error uploading avatar:', error);
      return { data: null, error };
    }
  },

  async getUserAvatarUrl(filePath) {
    try {
      if (!filePath) return { data: null, error: null };

      const { data, error } = await supabase?.storage
        ?.from('user-avatars')
        ?.createSignedUrl(filePath, 3600);

      if (error) throw error;
      return { data: data?.signedUrl, error: null };
    } catch (error) {
      console.error('Error getting avatar URL:', error);
      return { data: null, error };
    }
  },

  async deleteUserAvatar(filePath) {
    try {
      if (!filePath) return { error: null };

      const { error } = await supabase?.storage
        ?.from('user-avatars')
        ?.remove([filePath]);

      if (error) throw error;
      return { error: null };
    } catch (error) {
      console.error('Error deleting avatar:', error);
      return { error };
    }
  }
};